import { Plus } from "lucide-react";
import { Button } from "../../../../components/ui/common/button";
import { FacilityListHeaderProps } from "../types/facilityList.types";

/** Page title + subtitle + primary action, same shape as `ProductListHeader`. */
export const FacilityListHeader = ({ onRegisterClick }: FacilityListHeaderProps) => (
  <div className="tw-mb-6 tw-flex tw-items-center tw-justify-between tw-gap-4">
    <div>
      <h1 className="tw-font-display tw-text-2xl tw-font-bold tw-text-foreground">Facilities</h1>
      <p className="tw-mt-1 tw-text-sm tw-text-muted-foreground">
        Registered facilities with their power, heat, water and refrigerant sources
      </p>
    </div>
    <Button onClick={onRegisterClick} className="tw-shrink-0 tw-gap-2">
      <Plus className="tw-h-4 tw-w-4" />
      Register New Facility
    </Button>
  </div>
);
